import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import Vue from 'vue';
import Message from './message';

export default class MessageHandler extends Vue {
  public static handle(message: Message, eventId: string): Promise<Message> {
    return new Promise((resolve, reject) => {
      if (!message.checkEventId(eventId)) {
        reject();
      }
      if (message.isError()) {
        VbSnackbarService.handleHttpError(message.payload);
        reject(message);
      } else {
        resolve(message)
      }
    })
  }
}
